<template>
    <div>
    <div class="py-3"></div>
    
    <v-card
        class="mx-auto"
        max-width="90%"
    >
    <v-toolbar
        :color="'light-blue darken-3'"
        dark
    >    
    <v-toolbar-title>공지 이력</v-toolbar-title>
        <v-spacer/>
        <v-btn
            color="lime"
            small
            fab
            @click="OnClick_CreateItem"
        >
            <v-icon 
            color= "light-blue darken-3"
            >mdi-plus</v-icon>
        </v-btn>
    </v-toolbar>
    <v-list>
        <v-data-table         
        :footer-props="{'items-per-page-options':[20, 50, -1]}"
        :headers="headers" 
        :items="notice_history_all"
        :loading="loadingData"
        >        
        <template v-slot:item="row">            
            <tr>
            <td>{{row.item.PID}}</td>
            <td>{{row.item.TITLE}}</td>
            <td>{{row.item.CREATE_USER}}</td>
            <td>{{row.item.CREATE_DT}}</td>
            <!-- 추가되는 시작,종료일시 -->
            <!-- <td>{{row.item.START_DT}}</td>
            <td>{{row.item.END_DT}}</td> -->
            <td>
                <v-switch
                    v-model="row.item.active"
                    inset       
                    @change="Save_Change_ActiveState(row.item)"
                ></v-switch>
            </td>
            <td>
                <v-btn class="mx-2" fab dark small color="blue darken-1" @click="OnClickEdit_Item(row.item)">
                    <v-icon dark>mdi-pencil-outline</v-icon>
                </v-btn>
            </td>
            </tr>
        </template>
        </v-data-table>
    </v-list>
   
    </v-card>

    <v-dialog
      v-model="dialog"
      max-width="600"
    >
      <v-card>
        <v-card-title class="text-h5 mb-3">
            {{ dialog_title_text }}
        </v-card-title>

        <v-card-text>
            <v-text-field 
                label="공지 제목"
                v-model="selected_editing_item.TITLE" 
                outlined
                dense
            ></v-text-field>
            <v-row>
                        <v-col
                            cols="7">
                            <v-menu
                                ref="menu"
                                v-model="menu"
                                :close-on-content-click="false"
                                :return-value.sync="date"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="date"
                                    label="시작일 선택"
                                    prepend-icon="mdi-calendar"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                    outlined
                                    dense
                                ></v-text-field>
                                </template>
                                <v-date-picker
                                v-model="date"
                                no-title
                                scrollable
                                >
                                <v-spacer></v-spacer>
                                <v-btn
                                    text
                                    color="primary"
                                    @click="menu = false"
                                >
                                    취소
                                </v-btn>
                                <v-btn
                                    text
                                    color="primary"
                                    @click="$refs.menu.save(date)"
                                >
                                    확인
                                </v-btn>
                                </v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col
                            cols="5">
                            <v-menu
                                ref="menut1"
                                v-model="menut1"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                :return-value.sync="time1"
                                transition="scale-transition"
                                offset-y
                                max-width="290px"
                                min-width="290px"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="time1"
                                    label="시작 시간"
                                    prepend-icon="mdi-clock-time-four-outline"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                    outlined
                                    dense
                                ></v-text-field>
                                </template>
                                <v-time-picker
                                v-if="menut1"
                                v-model="time1"
                                full-width
                                :use-seconds="true"
                                @click:second="$refs.menut1.save(time1)"
                                ></v-time-picker>
                            </v-menu>
                        </v-col>
            </v-row>
            <v-row>
                        <v-col
                            cols="7">
                            <v-menu
                                ref="menu2"
                                v-model="menu2"
                                :close-on-content-click="false"
                                :return-value.sync="date2"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="date2"
                                    label="종료일 선택"
                                    prepend-icon="mdi-calendar"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                    outlined
                                    dense
                                ></v-text-field>
                                </template>
                                <v-date-picker
                                v-model="date2"
                                no-title
                                scrollable
                                >
                                <v-spacer></v-spacer>
                                <v-btn
                                    text
                                    color="primary"
                                    @click="menu2 = false"
                                >
                                    취소
                                </v-btn>
                                <v-btn
                                    text
                                    color="primary"
                                    @click="$refs.menu2.save(date2)"
                                >
                                    확인
                                </v-btn>
                                </v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col
                            cols="5">
                            <v-menu
                                ref="menut2"
                                v-model="menut2"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                :return-value.sync="time2"
                                transition="scale-transition"
                                offset-y
                                max-width="290px"
                                min-width="290px"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="time2"
                                    label="종료 시간"
                                    prepend-icon="mdi-clock-time-four-outline"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                    outlined
                                    dense
                                ></v-text-field>
                                </template>
                                <v-time-picker
                                v-if="menut2"
                                v-model="time2"
                                full-width
                                :use-seconds="true"
                                @click:second="$refs.menut2.save(time2)"
                                ></v-time-picker>
                            </v-menu>
                        </v-col>
            </v-row>
           
            <!-- <div id="editorjs"></div> -->
            <!-- <v-textarea
                filled
                v-model="selected_editing_item.MESSAGE"
                name="input-7-4"
                label="메시지를 입력하세요."
                value=""
            ></v-textarea> -->
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="green darken-1"
            text
            @click="CancelEdit"
          >
            취소
          </v-btn>

          <v-btn
            color="green darken-1"
            text
            @click="OnSave_EditingData"
          >
            SAVE
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    </div>

</template>


<script>

import { mapActions } from 'vuex';
import moment from 'moment'
import store from '../../store';
import config from '../../config/config';
import { format, parseISO } from 'date-fns'
export default {
    name: 'UserList',

    data: () => ({
        menu: false,
        menu2:false,
        menut1: false,
        menut2:false,
        // 디폴트 시간을 넣어준다.
        date:'',
        date2:'',
        time1:'',
        time2:'',
        dialog_title_text :'',
        dialog : false,
        loadingData:false,        
        noticeTitle:'',
        noticeMessage:'',
        create_date:'',
        headers: [            
            { text: '고유번호', value: 'pid' },
            { text: '타이틀', value: 'title' },            
            { text: '작성자', value: 'admin_user' },
            { text: '작성일', value: 'create_dt' },
            // 시작일시 종료일시 추가
            // { text: '시작일시', value: 'start_dt' },
            // { text: '종료일시', value: 'end_dt' },
            //
            { text: '활성상태', value: 'active_yn' },
            { text: '상세보기', value: 'edit' },
        ],
        notice_history_all:[
        ],
        selected_editing_item:{},
     
    }),

    created()
    {    
        this.LoadServerInfo();    
    },
    components: {
    },
    methods:{
        ...mapActions([
            'CREATE_QUIZ_NOTICE',
            'GET_QUIZ_NOTICE_LIST',
            'SET_QUIZ_NOTICE_INFO'
        ]),
        
        LoadServerInfo(){   
            this.loadingData = true;
            this.GET_QUIZ_NOTICE_LIST({}).then((body_data)=>{
                this.loadingData = false; 
                this.notice_history_all = body_data.notice_list;
                console.log(this.notice_history_all)
                for(let index = 0; index < this.notice_history_all.length ; index++)
                {
                    let notice_item = this.notice_history_all[index];
                    notice_item.active = notice_item.ENABLE_YN =="Y"?true:false;
                    this.notice_history_all[index] = notice_item;
                }
                
            })
            .catch((err) => {
                this.error = err;
                console.log(err);
            })
        },

        Save_Change_ActiveState(item)
        {
            let packageName = this.$store.state.selected_game_package;
            let notice_title = item.TITLE;
            let notice_message = item.MESSAGE;
            let enable_yn = item.ENABLE_YN == "Y"?"N":"Y";                        
            let pid = item.PID;    

            this.loadingData = true; 
            this.SET_QUIZ_NOTICE_INFO({packageName, notice_title, notice_message, enable_yn, pid  }).then((body_data)=>{
                this.loadingData = false; 
                if(enable_yn == 'Y')
                {
                    alert('공지가 활성화 되었습니다.');
                }
                else{
                    alert('공지가 비활성화 되었습니다.');
                }
                this.LoadServerInfo();
                //alert("??");
                //this.notice_history_all = body_data.notice_list;
            })
            .catch((err) => {
                this.error = err;
                console.log(err);
            })
            
        },
        IsItem_Active(item)
        {
            if(item.ENABLE_YN == 'Y')
                return true;
            else
                return false;
        },
        OnClickEdit_Item(item)
        {//아이템을 수정하려는 경우에 호출한다 
            this.dialog_title_text = "공지내용 수정하기";
            // // 변수의 속성을 미리 선언해두지 않고 들어온 데이터를 바로 넣어준 후 보여준다.
            // this.selected_editing_item = item;

            // this. appNoticeStartDateArr = this.selected_editing_item.START_DT.split(' ')
            // this.date = this.appNoticeStartDateArr[0]
            // this.time1 = this.appNoticeStartDateArr[1]

            // this. appNoticeEndDateArr = this.selected_editing_item.END_DT.split(' ')
            // this.date2 = this.appNoticeEndDateArr[0]
            // this.time2 = this.appNoticeEndDateArr[1]
            //this.dialog = true;
            this.$router.push(`/quiz_notice_write?pid=${item.PID}`);
            
        },

        OnClick_CreateItem()
        {
            //this.dialog_title_text = "공지내용 작성하기";
            // 디폴트 시간을 넣어준다.
            // this.date = format(parseISO(new Date().toISOString()), 'yyyy-MM-dd')
            // this.time1 = "00:00:00"
            // this.date2 = format(parseISO(new Date().toISOString()), 'yyyy-MM-dd')
            // this.time2 = "23:59:59"
            // this.selected_editing_item = {}; 
            this.$router.push(`/quiz_notice_write`);
        },

        SaveItem(item)
        {///이템의 pid 가 있으면 저장으로 없으면 생성으로 한다
            //selected_editing_item
        },
        CancelEdit()
        {
            this.dialog = false;    
        },
        IsActiveState(_item)
        {
            return _item.active_yn=="Y"?true:false;
        },
        OnSave_EditingData()
        {
            this.loadingData = true;
            this.dialog = false;
            let packageName = this.$store.state.selected_game_package;

            if(this.selected_editing_item.PID != undefined)
            {
                let item = this.selected_editing_item;
                let notice_title = item.TITLE;
                let notice_message = item.MESSAGE;
                let enable_yn = item.ENABLE_YN;
                let pid = item.PID;
                // 시간 정보가 추가된다.
                let start_dt = this.noticeStartDate
                let end_dt = this.noticeEndDate
                this.SET_QUIZ_NOTICE_INFO({packageName, notice_title, notice_message, enable_yn, pid, start_dt, end_dt  }).then((body_data)=>{
                this.loadingData = false; 
                this.LoadServerInfo();
                })
                .catch((err) => {
                    this.error = err;
                    console.log(err);
                })
            }
            else{
                console.log("TEST");
                let item = this.selected_editing_item;
                let notice_title = item.TITLE;
                let notice_message = item.MESSAGE;
                // 시간 정보가 추가된다.
                let start_dt = this.noticeStartDate
                let end_dt = this.noticeEndDate
                this.CREATE_QUIZ_NOTICE({packageName, notice_title, notice_message, start_dt, end_dt }).then((body_data)=>{
                    this.loadingData = false; 
                    this.LoadServerInfo();
                })
                .catch((err) => {
                    this.error = err;
                    console.log(err);
                })
            }
        }
        
    },
    computed: {
        isLive(){
            return config.isLive;
        },
        noticeStartDate () {
            return `${this.date} ${this.time1}`
        },
        noticeEndDate () {
            return `${this.date2} ${this.time2}`
        },
    },
 
    watch :{
            '$store.state.selected_game_package': function() {
            console.log("WHAT IS THIS? " + this.$store.state.selected_game_package)
            this.LoadServerInfo();
        },
    }
};
</script>
